<!-- 邮箱注册 -->
<template>
    <a-modal
        title="邮箱注册"
        width="400px"
        :visible="visible"
        :maskClosable="false"
        @ok="handleSubmit"
        @cancel="handleCancel"
        :confirmLoading="loading"
    >
        <a-form
            @submit="handleSubmit"
            :form="form">
            <a-form-item
                label="昵称"
                :required="true"
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
            >
                <a-input
                    v-decorator="['nickname', {rules: [{ required: true, message: '请输入昵称' }]}]"
                    placeholder="请输入昵称"/>
            </a-form-item>

            <a-form-item
                label="账号"
                :required="true"
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
            >
                <a-input
                    v-decorator="['account', {rules: [{ required: true, message: '请输入邮箱地址' }]}]"
                    placeholder="邮箱/中国大陆手机号"
                    @change="changeAccount"/>
            </a-form-item>
            <a-form-item
                label="验证码"
                :required="true"
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
            >
                <a-input-search
                    v-decorator="['checkCode', {rules: [{ required: true, message: '请输入验证码' }]}]"
                    placeholder="请输入验证码"
                    @search="sendCode()">
                    <a-button slot="enterButton" type="primary" :disabled="smsCode.codeBtnDisabled">{{ smsCode.codeBtnDisabled ? smsCode.times + '秒后重试' : '获取验证码' }}</a-button>
                </a-input-search>
            </a-form-item>
            <a-form-item
                label="密码"
                :required="true"
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
            >
                <a-input-password
                    v-decorator="['pwd', {rules: [{ required: true, message: '请输入密码' }]}]"
                    placeholder="请输入密码"/>
            </a-form-item>
            <a-form-item
                label="确认密码"
                :required="true"
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
            >
                <a-input-password
                    v-decorator="['repwd', {rules: [{ required: true, message: '请输入确认密码' }]}]"
                    placeholder="请输入确认密码"/>
            </a-form-item>
        </a-form>
    </a-modal>
</template>

<script>
import matchFun from '@comm/utils/matchFun'
export default {
    data () {
        return {
            visible: false,
            loading: false,
            form: this.$form.createForm(this),
            labelCol: {lg: {span: 6}},
            wrapperCol: {lg: {span: 16}},
            smsCode: {
                codeBtnDisabled: false,
                times: 60
            },
            params: {
                nickname: null,
                account: null,
                smsId: null,
                pwd: null,
                repwd: null,
                smsCode: null
            }
        }
    },
    methods: {
        show () {
            this.visible = true
        },
        handleSubmit () {
            this.form.validateFields((err, values) => {
                if (!err) {
                    const pwd = values['pwd']
                    const repwd = values['repwd']
                    if (pwd.trim().length < 6) {
                        this.$message.error('请输入至少6个字符的密码')
                        return
                    }
                    if (repwd != pwd) {
                        this.$message.error('两次密码不一致')
                        return
                    }
                    this.params.nickname = values['nickname']
                    this.params.account = values['account']
                    this.params.pwd = values['pwd']
                    this.params.repwd = values['repwd']
                    this.params.smsCode = values['checkCode']
                    this.registBySmsCode()
                }
            })
        },
        registBySmsCode () {
            this.loading = true
            this.$api.user.registBySmsCode(this.params).then(res => {
                if (res.status == 0) {
                    this.$message.success('账号注册成功')
                    this.handleCancel()
                } else {
                    this.$message.error(res.msg)
                }
            }).finally(_ => {
                this.loading = false
            })
        },
        handleCancel () {
            this.smsCode = {
                codeBtnDisabled: false,
                times: 60
            }
            this.params = {
                nickname: null,
                account: null,
                smsId: null,
                pwd: null,
                repwd: null,
                smsCode: null
            }
            this.visible = false
        },
        sendCode () {
            if (this.params.account == null) {
                this.$message.error('请输入邮箱地址或中国大陆手机号')
                return
            }
            if (!matchFun.phoneFun(this.params.account) && !matchFun.emailFun(this.params.account)) {
                this.$message.error('请输入正确的邮箱或中国大陆手机号')
                return
            }
            this.smsCode.codeBtnDisabled = true
            const interval = window.setInterval(() => {
                if (this.smsCode.times-- <= 0) {
                    this.smsCode.times = 60
                    this.smsCode.codeBtnDisabled = false
                    window.clearInterval(interval)
                }
            }, 1000)
            this.$api.user.sendRegisterSms({phone: this.params.account}).then(res => {
                if (res.status === 0) {
                    if (matchFun.phoneFun(this.params.account)) {
                        // 如果是手机号
                        this.$message.success('验证码发送成功')
                    } else {
                        this.$message.success('验证码发送成功，请登录您的邮箱获取验证码')
                    }
                    this.params.smsId = res.data
                } else {
                    this.$message.error(res.msg)
                    this.smsCode.codeBtnDisabled = false
                    this.smsCode.times = 60
                }
            })
        },
        changeAccount (e) {
            this.params.account = e.target.value
        },
    }
}
</script>

  


// WEBPACK FOOTER //
// src/comm/components/modal/RegistByMail.vue